export interface AdminAppsRouteOptions {
  query?: string | null
  status?: string | null
}

export function getAdminAppsPath(options: AdminAppsRouteOptions = {}): string {
  const params = new URLSearchParams()
  const query = options.query?.trim()
  const status = options.status?.trim()

  if (query) {
    params.set('query', query)
  }

  if (status && status !== 'all') {
    params.set('status', status)
  }

  const search = params.toString()
  return search ? `/admin/apps?${search}` : '/admin/apps'
}
